import { StyleSheet } from "@react-pdf/renderer";

export const MAPStyles = StyleSheet.create({
  page: {
    backgroundColor: "#ffffff",
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
  },

  section: {
    marginBottom: 20,
    paddingBottom: 10,

    // FIXED
    borderBottomWidth: 1,
    borderBottomColor: "#ddd",
    borderBottomStyle: "solid",
  },

  header: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 4,
    color: "#0a3d62",
  },

  subHeader: { fontSize: 12, fontWeight: 600, marginBottom: 6 },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 3,
  },

  textBold: { fontWeight: 600 },

  gridHeader: {
    flexDirection: "row",
    marginTop: 6,
    marginBottom: 4,
  },

  gridCell: { flex: 1, textAlign: "center" },

  warning: { color: "#f39c12", marginBottom: 3 },

  danger: { color: "#e74c3c" },
  success: { color: "#2ecc71" },
  yellow: { color: "#f1c40f" },

  box: {
    padding: 10,
    backgroundColor: "#f9f9f9",
    borderRadius: 6,
    marginTop: 6,

    // FIXED
    borderWidth: 1,
    borderColor: "#eee",
    borderStyle: "solid",
  },

  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    fontSize: 8,
    color: "#888",
  },
});
